import { render } from "./HolidayDestinations.vue?vue&type=template&id=30e450b6"
import script from "./HolidayDestinations.vue?vue&type=script&lang=js"
export * from "./HolidayDestinations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__